import { render } from "./FAQAdminItem.vue?vue&type=template&id=c506f922&scoped=true"
import script from "./FAQAdminItem.vue?vue&type=script&lang=js"
export * from "./FAQAdminItem.vue?vue&type=script&lang=js"

import "./FAQAdminItem.vue?vue&type=style&index=0&id=c506f922&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-c506f922"

export default script